var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiveMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.7985,
    height: 19.7495,
    viewBox: "0 0 18.7985 19.7495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06176 5.66933C2.48796 2.24469 5.82961 0.0100374 9.53934 0.000128852C13.5375 -0.0209255 17.0926 2.54006 18.339 6.3391C19.5853 10.1381 18.2381 14.3074 15.0044 16.6588C11.7707 19.0103 7.38925 19.0068 4.15934 16.6501L1.27934 19.5301C0.986523 19.8226 0.512158 19.8226 0.21934 19.5301C-0.0731133 19.2373 -0.0731133 18.7629 0.21934 18.4701L3.00934 15.6801C0.403243 13.04 -0.364444 9.09396 1.06176 5.66933ZM2.39891 12.1691C3.59638 15.0547 6.41508 16.9342 9.53934 16.9301V16.8901C13.7796 16.8847 17.2219 13.4603 17.2493 9.22013C17.2534 6.09586 15.374 3.27717 12.4883 2.0797C9.60261 0.882226 6.27967 1.54208 4.07048 3.75127C1.86129 5.96046 1.20144 9.2834 2.39891 12.1691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveMagnifier);
export default __webpack_public_path__ + "static/media/hive-magnifier.de481ef9abc22f02819cf2876bece7d1.svg";
export { ForwardRef as ReactComponent };